import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AuthenticationService } from '../../../core/authentication';
import { ToastrService } from "ngx-toastr";
import { ServiceProvider } from '../../../core/service/service.provider';
import { LocalStorageService } from '../../../shared/local-storage.service'

@Component({
  selector: 'app-roleselect-form',
  templateUrl: './roleselect-form.component.html'
})
export class RoleSelectFormComponent implements OnInit {
  seletedRole;
  loading = false;
  submitted = false;
  roles;
  // returnUrl: string;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private toastr: ToastrService,
    public dataService: ServiceProvider,
    private storage: LocalStorageService,
  ) { 
  }

  ngOnInit() {
    this.roles = this.storage.getData("roles")
  }



  roleSelectedGoToNext() {
    this.submitted = true;
    this.loading = true;
    let role_data = this.roles.find(data => data.id == this.seletedRole)
    localStorage.setItem('userRole', JSON.stringify(role_data))
    this.toastr.success('Logged in successfully', 'Success');
    this.router.navigate(['/dashboard']);
  }


}